import { HttpParams } from '@angular/common/http';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Gruppe } from '../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { DateTableColumn, NumberTableColumn, TableColumn } from '../../../components/kiene-table/table-column';
import { TableDescriptor } from '../../../components/kiene-table/table-descriptor';
import { BefundmitteilungPosition } from '../../../../../src/app/laboratory/befundmitteilung/befundmitteilung';
import { AbgabebelegPosition } from '../../../../../projects/kiene-core/src/lib/components/abgabebelege/classes/abgabebeleg-position';

export class BelegStatistik {
    kosten_abgabebelege: number;
    kosten_befunde: number;
    anzahl_abgabebelege: number;
    anzahl_befunde: number;
}

@Component({
    selector: 'kiene-gruppe-belege',
    templateUrl: './gruppe-belege.component.html',
    styleUrls: ['./gruppe-belege.component.scss'],
})
export class GruppeBelegeComponent implements OnInit {
    @Input() gruppe!: Gruppe;

    public tableDescriptorAbgabebelege: TableDescriptor = new TableDescriptor();
    public tableDescriptorBefunde: TableDescriptor = new TableDescriptor();
    statistiken: BelegStatistik;

    constructor(
        private api: KieneBackendApiService,
        private messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private pdfViewerService: PdfViewerDesktopService,
        private router: Router,
    ) {}

    public ngOnInit(): void {
        this.createTableAbgabebelegPositionen();
        this.createTableBefunde();
        this.loadStatistiken();
    }

    private loadStatistiken(): void {
        const params = new HttpParams().set('gruppe_id', this.gruppe?.gruppe_id);
        this.api.get(this.apiBaseUrl + 'gruppe/read_kosten.php', params).subscribe({
            next: (response: BelegStatistik) => {
                this.statistiken = response;
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Laden der Statistik', error);
            },
        });
    }

    public downloadAbgabebelegePositionenPdf(): void {
        const url = 'abgabebeleg/read_pdf_belege.php';
        const params = new HttpParams().set('gruppe_id', this.gruppe.gruppe_id);

        const input = new PdfViewerDialogInput(url, params, 'Abgabebelege');
        this.pdfViewerService.openPdfViewer(input);
    }

    public downloadBefundPositionenPdf(): void {
        const url = 'befund/read_pdfs.php';
        const params = new HttpParams().set('gruppe_id', this.gruppe.gruppe_id);

        const input = new PdfViewerDialogInput(url, params, 'Befunde');
        this.pdfViewerService.openPdfViewer(input);
    }

    gotoAbgabebeleg(abgabebeleg: AbgabebelegPosition) {
        this.router.navigate(['belege', 'abgabebelege', abgabebeleg?.abgabebeleg_id]).then();
    }

    gotoBefund(befund: BefundmitteilungPosition) {
        this.router.navigate(['befundmitteilungen', befund?.befund_id]).then();
    }

    private createTableAbgabebelegPositionen(): void {
        this.tableDescriptorAbgabebelege.headline = 'Abgabebeleg-Positionen';
        this.tableDescriptorAbgabebelege.uniqueIdentifier = 'Gruppe-Abgabebeleg-Positionen';
        this.tableDescriptorAbgabebelege.apiUrl = this.apiBaseUrl + 'abgabebelege_positionen/';
        this.tableDescriptorAbgabebelege.route = '/belege/abgabebelege/';
        this.tableDescriptorAbgabebelege.params = new HttpParams().set('gruppe_id', this.gruppe?.gruppe_id);
        this.tableDescriptorAbgabebelege.nameOfIdField = 'abgabebeleg_id';
        this.tableDescriptorAbgabebelege.searchPlaceholder = 'Abgabebeleg-Positionen durchsuchen';
        this.tableDescriptorAbgabebelege.createAllowed = false;
        this.tableDescriptorAbgabebelege.standardCreate = false;
        this.tableDescriptorAbgabebelege.showDetails = true;
        this.tableDescriptorAbgabebelege.showDetailsVoid = this.gotoAbgabebeleg.bind(this);
        this.tableDescriptorAbgabebelege.selectable = false;
        this.tableDescriptorAbgabebelege.showDownloads = false;
        this.tableDescriptorAbgabebelege.showRefresh = true;
        this.tableDescriptorAbgabebelege.expandable = false;
        this.tableDescriptorAbgabebelege.initialSortColumn = 'aa_id';
        this.tableDescriptorAbgabebelege.initialSortDirection = 'desc';

        this.tableDescriptorAbgabebelege.permissionView = 1231;
        this.tableDescriptorAbgabebelege.toolbarButtons = [];
        this.tableDescriptorAbgabebelege.selectionToolbarButtons = [];
        this.tableDescriptorAbgabebelege.options = [];

        this.tableDescriptorAbgabebelege.columns.push(new TableColumn('aa_id', 'ID'));
        this.tableDescriptorAbgabebelege.columns.push(new TableColumn('abgabebeleg_nr', 'Abgabebeleg-Nr.'));
        this.tableDescriptorAbgabebelege.columns.push(new DateTableColumn('datum', 'Datum', 'dd.MM.yy'));
        this.tableDescriptorAbgabebelege.columns.push(new TableColumn('artikel_me', 'Artikel'));
        this.tableDescriptorAbgabebelege.columns.push(new TableColumn('tierart', 'Tierart'));
        this.tableDescriptorAbgabebelege.columns.push(new TableColumn('anwendung', 'Anwendung'));
        this.tableDescriptorAbgabebelege.columns.push(new TableColumn('diagnose', 'Diagnose'));
        this.tableDescriptorAbgabebelege.columns.push(new TableColumn('artikelmenge', 'Artikelmenge'));
        this.tableDescriptorAbgabebelege.columns.push(new TableColumn('dosierung', 'Dosierung'));
        this.tableDescriptorAbgabebelege.columns.push(new TableColumn('anwendungsdauer', 'Anwendungsdauer'));
        this.tableDescriptorAbgabebelege.columns.push(new TableColumn('tiergewicht', 'Tiergewicht'));
        this.tableDescriptorAbgabebelege.columns.push(new TableColumn('identifikation', 'Identifikation'));
        this.tableDescriptorAbgabebelege.columns.push(new TableColumn('wartezeit', 'Wartezeit Fl.'));
        this.tableDescriptorAbgabebelege.columns.push(new NumberTableColumn('einzelpreis', 'Einzelpreis (€)', '1.2-2'));
        this.tableDescriptorAbgabebelege.columns.push(
            new NumberTableColumn('position_preis', 'Gesamtpreis (€)', '1.2-2'),
        );
    }

    private createTableBefunde(): void {
        this.tableDescriptorBefunde.headline = 'Befund-Positionen';
        this.tableDescriptorBefunde.uniqueIdentifier = 'Befund-Positionen';
        this.tableDescriptorBefunde.apiUrl = this.apiBaseUrl + 'befunde_positionen/';
        this.tableDescriptorBefunde.params = new HttpParams().set('gruppe_id', this.gruppe?.gruppe_id);
        this.tableDescriptorBefunde.nameOfIdField = 'befund_id';
        this.tableDescriptorBefunde.createAllowed = false;
        this.tableDescriptorBefunde.standardCreate = false;
        this.tableDescriptorBefunde.showDetails = true;
        this.tableDescriptorBefunde.showDetailsVoid = this.gotoBefund.bind(this);
        this.tableDescriptorBefunde.showDownloads = false;
        this.tableDescriptorBefunde.initialSortColumn = 'ba_id';
        this.tableDescriptorBefunde.initialSortDirection = 'desc';

        this.tableDescriptorBefunde.columns.push(new TableColumn('ba_id', 'ID'));
        this.tableDescriptorBefunde.columns.push(new TableColumn('tagebuch_nr', 'Tagebuch-Nr'));
        this.tableDescriptorBefunde.columns.push(new TableColumn('untersuchungsmaterial', 'Untersuchungsmaterial'));
        this.tableDescriptorBefunde.columns.push(new TableColumn('artikel_me', 'Artikel'));
        this.tableDescriptorBefunde.columns.push(new TableColumn('artikelmenge', 'Menge'));
        this.tableDescriptorBefunde.columns.push(new DateTableColumn('eingang', 'Eingang', 'dd.MM.yy'));
        this.tableDescriptorBefunde.columns.push(new DateTableColumn('probenentnahme', 'Probenentnahme', 'dd.MM.yy'));
        this.tableDescriptorBefunde.columns.push(new NumberTableColumn('einzelpreis', 'Einzelpreis (€)', '1.2-2'));
        this.tableDescriptorBefunde.columns.push(new NumberTableColumn('gesamtpreis', 'Gesamtpreis (€)', '1.2-2'));

        this.tableDescriptorBefunde.permissionView = 1281;
    }
}
